/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { of, throwError } from "rxjs";
import { HttpRequestOptions } from "../../../../models/ui/http-request-options.model";
import {
	GET_CALCULATOR_FORM_DATA_RESPONSE,
	GET_CLOUD_PROVIDER_OPTIONS_RESPONSE,
	GET_ON_PREMISE_OPTIONS_RESPONSE,
	START_CALCULATOR_RESPONSE
} from "./calculator.db";
import { ApplicationError } from "../../../../models/ui/application-error.model";

export class Calculator {
	public static getCalculatorFormData() {
		return of(GET_CALCULATOR_FORM_DATA_RESPONSE);
	}

	public static getOnPremiseOptions() {
		return of(GET_ON_PREMISE_OPTIONS_RESPONSE);
	}

	public static getCloudProviderOptions(options: HttpRequestOptions) {
		const { pathParams } = options;

		const id = pathParams?.["id"];

		if (!id)
			return throwError(
				() =>
					new ApplicationError(
						"No cloud provider id provided",
						this.constructor.name,
						this.getCloudProviderOptions.name
					)
			);

		return of(GET_CLOUD_PROVIDER_OPTIONS_RESPONSE);
	}

	public static startCalculator(options: HttpRequestOptions) {
		const { pathParams, body } = options;

		const tenantId = pathParams?.["tenantId"];

		if (!tenantId)
			return throwError(
				() =>
					new ApplicationError(
						"No tenant token provided",
						this.constructor.name,
						this.startCalculator.name
					)
			);

		if (!body)
			return throwError(
				() =>
					new ApplicationError(
						"No calculator options provided",
						this.constructor.name,
						this.startCalculator.name
					)
			);

		return of(START_CALCULATOR_RESPONSE);
	}
}
